import { Snackbar, Alert } from "@mui/material";
import { useEffect, useState } from "react";

export default function SoftNotification({
  alert,
  message,
  severity = "warning",
  autoHideDuration = 2000,
  anchorOrigin = { vertical: "bottom", horizontal: "right" },
  onClose
}) {
  const [open, setOpen] = useState(true);

  useEffect(() => {
    setOpen(true);
  }, [alert, message]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;

    setOpen(false);
    onClose?.();
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      disableWindowBlurListener
      anchorOrigin={anchorOrigin}
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {message ?? `🚨 Nova notificação crítica no trem ${alert?.tremNome ?? alert?.tremId}`}
      </Alert>
    </Snackbar>
  );
}